var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e12524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#51b422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#429919"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#258de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1276cc"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.66901371 6.8050944c.07339277-.07645153.13338941-.22591146.13394903-.32382202l.00550141-.96254476c.00058522-.10239044-.08822605-.18539429-.19239999-.18539429h-.18450927c-.10684482 0-.13367427-.05978538-.06074597-.13271368l.4964774-.49647739c.07329578-.07329575.19249905-.0729283.26542736 0l.49647741.49647739c.07329577.07329575.04342796.13271368-.06074599.13271368h-.18450925c-.1068448 0-.19345966.08748373-.19345966.18539429v.96254476c0 .10239044.06026789.24566214.13020831.31560262l-.06994042-.06994048c.07191207.07191208.04867116.13020834-.06205242.13020834h-.37738332c-.10618263 0-.13440411-.06026786-.05937127-.13842774z",
    fill: "#159940",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 5.33333333 5.71428571-5.33333333 5.71428569z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGq);
export default __webpack_public_path__ + "static/media/GQ.accb80398dfafc14757c6f71adb852ee.svg";
export { ForwardRef as ReactComponent };